import Loader from "common/loader";
import { ProtectedRoute } from "components";
import Overview from "components/Remit/overview";
import DefaultLayout from "layouts/DefaultLayout";
import RoleandgroupsPage from "pages/Accessandroles";
import ApprovalsPage from "pages/Approvals";
import BranchDetails from "pages/BranchDetails/index";
import BranchRegistrationPage from "pages/BranchRegistration";
import ConfirmCollection from "pages/ConfirmCollection";
import ContactPage from "pages/Contacts";
import CreateContact from "pages/Create Opportunities";
import CollectDocs from "pages/Create Opportunities/collectdocs";
import CreateCollection from "pages/CreateCollection";
import CorporateLead from "pages/CreateCorporateLead";
import DealSuccess from "pages/CreateDeal/dealsuccess";
import CreateOldDeal from "pages/CreateDeal/oldcreatedeal";
import CreateForexQuotation from "pages/CreateForexQuotation";
import CreateOrder from "pages/CreateOrder";
import CreatePartnerLead from "pages/CreatePartnerLead";
import CreatePayout from "pages/CreatePayout";
import CreateRemit from "pages/CreateRemit/Index";
import Ordersuccess from "pages/CreateRemit/ordersuccess";
import CreateStaffPage from "pages/CreateStaff";
import LoginPage1 from "pages/CustomerApp/login";
import CustomerDetailsPage from "pages/CustomerDetails";
import CustomerRegistration from "pages/CustomerRegistration";
import NewCustomersPage from "pages/Customers/newcustomer";
import DashboardPage from "pages/Dashboard";
import DealDetailsPage from "pages/DealDetails";
import NewDealDetailsPage from "pages/DealDetails/newdealdetails";
import DealsPage from "pages/Deals";
import TaskPage from "pages/Deals/newdealpage";
import EntryForm from "pages/EntryForm";
import NewFinancePage from "pages/Finance/newfinance";
import ReportsPage from "pages/Reports";
import ForgetPasswordPage from "pages/ForgetPassword";
import ResetPasswordPage from "pages/ResetPassword";
import Groups from "pages/Groups";
import CreateGroup from "pages/Groups/create group";
import GroupList from "pages/Groups/overview";
import Home from "pages/Home";
import HomeLayout from "pages/HomeLayout";
import LeadContacts from "pages/LeadContacts";
import CorporateContact from "pages/LeadContacts/corporate_contact";
import PartnerContact from "pages/LeadContacts/partner_contact";
import Leads from "pages/Leads";
import LeadGeneric from "pages/Leads/lead";
import LoginPage from "pages/Login";
import LogoutPage from "pages/Logout";
import NotFound from "pages/NotFound";
import Opportunities from "pages/Opportunities";
import Corporateleaddetail from "pages/Opportunities/corporateleaddetail";
import OpportunitiesOverview from "pages/Opportunities/overview";
import Partnerleaddetail from "pages/Opportunities/partnerleaddetail";
import OpportunitiesSheet from "pages/Opportunities/Sheet";
import NewOrderDetailsPage from "pages/OrderDetails/neworderdetails";
import OrdersPage from "pages/Orders/neworders";
import PartnerDetailsPage from "pages/PartnerDetails";
import PartnerRegistration from "pages/PartnerRegistration";
import NewPartnersPage from "pages/Partners/newpartners";
import Profile from "pages/Profile";
import NotificationPreferences from "pages/Profile/notficationpreference";
import Quotation from "pages/Quotations";
import QuotationOverview from "pages/Quotations/overview";
import RedirectPortal from "pages/Redirect Portal";
import RedirectExisting from "pages/Redirect Portal/existing";
import OrderSuccess from "pages/Redirect Portal/ordersuccess";
import Payment from "pages/Redirect Portal/payment";
import Track from "pages/Redirect Portal/track";
import Remit from "pages/Remit";
import SetPasswordPage from "pages/SetPassword";
import StaffPage from "pages/Staff";
import StaffdetailsPage from "pages/StaffDetails";
import { lazy, Suspense, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter,
  HashRouter,
  Routes,
  useLocation,
} from "react-router-dom";
import CorporateRegistration from "pages/CorporateRegistration";
import RegisterBusiness from "pages/RegisterBusiness";
import ApplicationReview from "pages/ApplicationReview";
import OpportunityDetails from "pages/Opportunities/opportunitydetails";
import OrderDetails from "pages/OrderDetails";
import GetOuoteSteps from "pages/GetQuote";
import PrepareOuoteSteps from "pages/PrepareQuoteConatct";
import CreateQuote from "pages/CreateQuote";
import ReatilsCreateLead from "pages/RetailsCreateLead";
import L2CreateRemittanceQuotation from "pages/L2CreateRemittanceQuote/step1";
import MyCompanyPage from "pages/MyCompany";
import MyCompanyDetailsPage from "pages/MyCompany/companyComp";
import { BookDealAndRatePage } from "pages/BookDealandRate";
import BookDealDealSuccess from "pages/BookDealandRate/L1Flow/dealsuccess";
import CreateOrderL2 from "pages/CreateOrder/Agent";
import { checkLevel } from "common/rules";
import { LEVEL_2 } from "common/constants";
import RefundLayout from "pages/RefundOrder";
import Index from "pages/RefundOrder/steps";
import ForexOrderPage from "pages/ForexOrderList";
import Forex from "pages/Forex";
import ForexNewOrderDetailsPage from "pages/GenericOrderDetailsPage/entry";
import ForexOrderDetails from "pages/GenericOrderDetailsPage";
import TravelBookingPage from "pages/GenericOrder/order/page";
import CreateNewDeal from "pages/CreateDeal/components/CreateNewDeal";
import RegistrationFlow from "pages/AssistedPartnerRegistration/RegistrationFlow";
import ForexRefund from "pages/RefundOrder/forex";
import CancelOrderLayout from "pages/CancelOrder";
import CancelForexOrder from "pages/CancelOrder/forex";
// import ReKYCPage from "pages/ReKYC/page";
import GenericAllProduct from "pages/GenericAllProductOrder";
import CreateGenericOrderPage from "pages/CreateGenericOrder";
import GenericOrderPage from "pages/GenericAllProductOrder/GenericOrderPage";
const Reports = lazy(() => import("pages/Reports"));
const Settings = lazy(() => import("pages/Settings"));
const Company = lazy(() => import("pages/Company"));
const Createregion = lazy(() => import("pages/CreateRegion"));
const TestPage = lazy(() => import("pages/Test")); //testing page
const mydefaultmargin = lazy(() => import("pages/mydefaultmargin"));
const mymargins = lazy(() => import("pages/MyMargin"));
const Region = lazy(() => import("pages/Region"));
const GicOrders = lazy(() => import("pages/Gic-Orders"));
const ConfirmPayout = lazy(() => import("pages/ConfirmPayout"));
const RetailInteraction = lazy(() => import("pages/CreateRetailInteraction"));
const CorporateInteraction = lazy(
  () => import("pages/CreateCompanyInteraction"),
);
const FeedbackPage = lazy(() => import("pages/Feedback"));

// Hash routes in the click-through preview so deep links work from a static folder.
const Router = import.meta.env.VITE_BUSINESS_PREVIEW === "1" ? HashRouter : BrowserRouter;

const ProjectRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <Routes>
          {/* AUTH */}

          <Route path="/" element={<LoginPage />} />
          <Route path="/test" element={<TestPage />} />
          <Route
            path="/logout"
            element={<ProtectedRoute element={LogoutPage} />}
          />
          <Route path="/forgetpassword" element={<ForgetPasswordPage />} />
          {/* Where the link in the reset email lands. */}
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Public feedback form */}
          <Route path="/feedback" element={<FeedbackPage />} />
          {/* New backend (replaces Xano); own login, not the Xano session */}
          <Route
            path="/setpassword"
            element={<ProtectedRoute element={SetPasswordPage} />}
          />
          <Route
            path="/createRemit"
            element={<ProtectedRoute element={CreateRemit} />}
          />
          <Route
            path="/createnewdeal"
            element={<ProtectedRoute element={CreateNewDeal} />}
          />

          <Route
            path="/bookdeal"
            element={<ProtectedRoute element={BookDealAndRatePage} />}
          />

          {/* DefaultLayout */}
          <Route path="/" element={<DefaultLayout />}>
            <Route
              path="/profile"
              element={<ProtectedRoute element={Profile} />}
            >
              <Route
                index
                element={<ProtectedRoute element={NotificationPreferences} />}
              />
            </Route>
            <Route
              path="/mycompany"
              element={<ProtectedRoute element={MyCompanyPage} />}
            >
              <Route
                index
                element={<ProtectedRoute element={MyCompanyDetailsPage} />}
              />
            </Route>

            <Route
              path="/company"
              element={<ProtectedRoute element={Company} />}
            />
            {/* generic order page */}
            <Route
              path="/genericOrder/:id"
              element={<ProtectedRoute element={GenericOrderPage} />}
            />

            <Route
              path="/createregion"
              element={<ProtectedRoute element={Createregion} />}
            />
            {/* The original home screen, now reading from the new backend. */}
            <Route
              path="/dashboard"
              element={<ProtectedRoute element={DashboardPage} />}
            />
            <Route
              path="/genericOrder"
              element={<ProtectedRoute element={GenericAllProduct} />}
            ></Route>
            <Route path="/remit" element={<ProtectedRoute element={Remit} />}>
              <Route
                path="orders"
                element={<ProtectedRoute element={OrdersPage} />}
              />
              <Route
                path="olddeals"
                element={
                  <ProtectedRoute
                    element={<DealsPage />}
                  />
                }
              />
              <Route
                path="leads"
                index={checkLevel(LEVEL_2)}
                element={
                  <ProtectedRoute element={<LeadGeneric type="Remittance" />} />
                }
              />
              <Route
                path="deals"
                element={
                  <ProtectedRoute
                    element={<TaskPage />}
                  />
                }
              />
              <Route
                path="deals/new"
                element={
                  <ProtectedRoute
                    element={CreateNewDeal}
                    requires="order.status"
                  />
                }
              />
              <Route
                path="dealdetails/:id"
                element={<ProtectedRoute element={NewDealDetailsPage} />}
              />
              <Route
                path="dealsuccess"
                element={<ProtectedRoute element={DealSuccess} />}
              />
              <Route
                path="bookdealdealsuccess"
                element={<ProtectedRoute element={BookDealDealSuccess} />}
              />
              <Route
                path="ordersuccess"
                element={<ProtectedRoute element={Ordersuccess} />}
              />
              <Route
                index={!checkLevel(LEVEL_2)}
                element={<ProtectedRoute element={Overview} />}
              />
            </Route>

            {/* for forex */}
            <Route path="/forex" element={<ProtectedRoute element={Forex} />}>
              <Route
                path="orders"
                element={
                  <ProtectedRoute element={ForexOrderPage} />
                }
              />
              <Route
                path="leads"
                index={checkLevel(LEVEL_2)}
                element={
                  <ProtectedRoute element={<LeadGeneric type="Forex" />} />
                }
              />
            </Route>
            <Route
              path="/forex/orderdetails"
              element={<ProtectedRoute element={ForexOrderDetails} />}
            >
              <Route
                path=":id"
                element={<ProtectedRoute element={ForexNewOrderDetailsPage} />}
              />
            </Route>
            <Route
              path="/orderdetails"
              element={<ProtectedRoute element={OrderDetails} />}
            >
              <Route
                path=":id"
                element={<ProtectedRoute element={NewOrderDetailsPage} />}
              />
            </Route>

            <Route
              path="/quotations"
              element={<ProtectedRoute element={Quotation} />}
            >
              <Route
                index
                element={
                  <ProtectedRoute
                    element={<QuotationOverview activeTab="forex" />}
                  />
                }
              />
            </Route>
            <Route
              path="/entry-form"
              element={<ProtectedRoute element={EntryForm} />}
            />
            <Route
              path="/dealdetails2:id"
              element={<ProtectedRoute element={DealDetailsPage} />}
            />

            <Route
              path="/"
              element={
                <ProtectedRoute
                  element={
                    <HomeLayout
                      name={`${checkLevel(LEVEL_2) ? "Contact" : "Retail"}`}
                    />
                  }
                />
              }
            >
              <Route
                path="/lead/contacts"
                element={<ProtectedRoute element={LeadContacts} />}
              />
            </Route>

            <Route
              path="/"
              element={<ProtectedRoute element={<HomeLayout name="" />} />}
            >
              <Route
                path="/staff"
                element={<ProtectedRoute element={StaffPage} />}
              />
            </Route>
            <Route
              path="/"
              element={
                <ProtectedRoute element={<HomeLayout name="Corporate" />} />
              }
            >
              <Route
                path="/lead/contacts/corporate"
                element={
                  <ProtectedRoute
                    element={CorporateContact}
                  />
                }
              />
              <Route
                path="/applications/:id"
                element={<ProtectedRoute element={ApplicationReview} />}
              />
            </Route>

            <Route
              path="/"
              element={
                <ProtectedRoute element={<HomeLayout name="Customer" />} />
              }
            >
              <Route
                path="/customers"
                element={<ProtectedRoute element={NewCustomersPage} />}
              />
            </Route>

            <Route
              path="/"
              element={
                <ProtectedRoute element={<HomeLayout name="Partners" />} />
              }
            >
              <Route
                path="/lead/contacts/partner"
                element={
                  <ProtectedRoute
                    element={PartnerContact}
                  />
                }
              />
            </Route>
            <Route
              path="/"
              element={<ProtectedRoute element={<HomeLayout name="" />} />}
            >
              <Route
                path="/finance"
                element={<ProtectedRoute element={NewFinancePage} />}
              />
              <Route
                path="/reports"
                element={<ProtectedRoute element={ReportsPage} />}
              />
            </Route>
            <Route
              path="/"
              element={<ProtectedRoute element={<HomeLayout name="" />} />}
            >
              <Route
                path="/accessandroles"
                element={<ProtectedRoute element={RoleandgroupsPage} />}
              />
            </Route>
            <Route
              path="/"
              element={<ProtectedRoute element={<HomeLayout name="" />} />}
            >
              <Route
                path="/approvals"
                element={<ProtectedRoute element={ApprovalsPage} />}
              />
            </Route>
            <Route
              path="/"
              element={
                <ProtectedRoute element={<HomeLayout name="Partners" />} />
              }
            >
              <Route
                path="/partners"
                element={<ProtectedRoute element={NewPartnersPage} />}
              />
            </Route>

            <Route
              path="/reports"
              element={<ProtectedRoute element={Reports} />}
            />
            <Route
              path="/settings"
              element={<ProtectedRoute element={Settings} />}
            />
            <Route
              path="/branchregistration"
              element={<ProtectedRoute element={BranchRegistrationPage} />}
            />
            <Route
              path="/branchregistration:id"
              element={<ProtectedRoute element={BranchRegistrationPage} />}
            />
            {/* The original customer screen, now reading from the new backend. */}
            <Route
              path="/customerdetails/:id"
              element={
                <ProtectedRoute
                  element={CustomerDetailsPage}
                  requires="customer.read"
                />
              }
            />
            <Route path="/leads" element={<ProtectedRoute element={Leads} />}>
              <Route
                index
                element={<ProtectedRoute element={OpportunitiesOverview} />}
              />
              <Route
                path="contact/:id"
                element={<ProtectedRoute element={OpportunityDetails} />}
              />
              <Route
                path="partner/:id"
                element={<ProtectedRoute element={Partnerleaddetail} />}
              />
              <Route
                path="corporate/:id"
                element={<ProtectedRoute element={Corporateleaddetail} />}
              />
              <Route
                path="visa"
                element={
                  <ProtectedRoute element={<LeadGeneric type="Visa" />} />
                }
              />
              <Route
                path="forex"
                element={
                  <ProtectedRoute element={<LeadGeneric type="Forex" />} />
                }
              />
              <Route
                path="travel"
                element={
                  <ProtectedRoute element={<LeadGeneric type="Travel" />} />
                }
              />
              <Route
                path="study_abroad"
                element={
                  <ProtectedRoute
                    element={<LeadGeneric type="Study Abroad" />}
                  />
                }
              />
              <Route
                path="loan"
                element={
                  <ProtectedRoute element={<LeadGeneric type="Loan" />} />
                }
              />
            </Route>

            <Route path="/group" element={<ProtectedRoute element={Groups} />}>
              <Route index element={<ProtectedRoute element={GroupList} />} />
              {/* <Route
              path="createlead"
              element={<ProtectedRoute element={CreateContact} />}
            />
            <Route
              path="createcontact"
              element={<ProtectedRoute element={<OpportunitiesSheet />} />}
            /> */}
            </Route>

            <Route
              path="/staffdetails/:id"
              element={<ProtectedRoute element={StaffdetailsPage} />}
            />
            <Route
              path="/mydefaultmargin"
              element={<ProtectedRoute element={mydefaultmargin} />}
            />
            {/* The original partner screen, now reading from the new backend. */}
            <Route
              path="/partnerdetails/:id"
              element={
                <ProtectedRoute
                  element={PartnerDetailsPage}
                  requires="customer.read"
                />
              }
            />
            <Route
              path="/branchdetails:id"
              element={<ProtectedRoute element={BranchDetails} />}
            />
            <Route
              path="/regions"
              element={<ProtectedRoute element={Region} />}
            />
            <Route
              path="/gicorders"
              element={<ProtectedRoute element={GicOrders} />}
            />
            <Route
              path="/mymargins"
              element={<ProtectedRoute element={mymargins} />}
            />
            <Route
              path="/createcollection"
              element={<ProtectedRoute element={CreateCollection} />}
            />
            <Route
              path="/confirmcollection:id"
              element={<ProtectedRoute element={ConfirmCollection} />}
            />
            <Route
              path="/createpayout"
              element={<ProtectedRoute element={CreatePayout} />}
            />
            <Route
              path="/confirmpayout:id"
              element={<ProtectedRoute element={ConfirmPayout} />}
            />

            <Route
              path="/contacts"
              element={<ProtectedRoute element={ContactPage} />}
            />
            <Route
              path="/retailinteraction"
              element={<ProtectedRoute element={RetailInteraction} />}
            />
            <Route
              path="/corporateinteraction"
              element={<ProtectedRoute element={CorporateInteraction} />}
            />
          </Route>
          <Route
            path="/refund"
            element={<ProtectedRoute element={<RefundLayout />} />}
          >
            <Route index element={<ProtectedRoute element={Index} />} />
          </Route>
          <Route
            path="/refund/forex/:id"
            element={<ProtectedRoute element={<RefundLayout />} />}
          >
            <Route index element={<ProtectedRoute element={ForexRefund} />} />
          </Route>
          <Route
            path="/cancel/forex/:id"
            element={<ProtectedRoute element={<CancelOrderLayout />} />}
          >
            {" "}
            <Route
              index
              element={<ProtectedRoute element={CancelForexOrder} />}
            />
          </Route>

          <Route
            path="/createforexquotation"
            element={
              <ProtectedRoute
                element={<ProtectedRoute element={CreateForexQuotation} />}
              />
            }
          />

          <Route
            path="/createremittancequotation"
            element={<ProtectedRoute element={L2CreateRemittanceQuotation} />}
          />
          <Route
            path="/l2createremittancequotation"
            element={<ProtectedRoute element={L2CreateRemittanceQuotation} />}
          />
          <Route
            path="/lead"
            element={<ProtectedRoute element={Opportunities} />}
          >
            <Route index element={<Navigate to="/" replace />} />
            <Route
              path="createlead"
              element={<ProtectedRoute element={CreateContact} />}
            />
            <Route
              path="getquote"
              element={<ProtectedRoute element={GetOuoteSteps} />}
            />
            <Route
              path="preparequotecontact"
              element={<ProtectedRoute element={PrepareOuoteSteps} />}
            />
            <Route
              path="retails/createlead"
              element={<ProtectedRoute element={ReatilsCreateLead} />}
            />
            <Route
              path="partner/createlead"
              element={<ProtectedRoute element={CreatePartnerLead} />}
            />
            <Route
              path="corporate/createlead"
              element={<ProtectedRoute element={CorporateLead} />}
            />
            <Route
              path="createcontact"
              element={
                <ProtectedRoute element={<OpportunitiesSheet type="multi" />} />
              }
            />
            <Route
              path="createcontact/partner"
              element={
                <ProtectedRoute
                  element={<OpportunitiesSheet type="partner" />}
                />
              }
            />
            <Route
              path="createcontact/corporate"
              element={
                <ProtectedRoute
                  element={<OpportunitiesSheet type="corporate" />}
                />
              }
            />
          </Route>
          <Route
            path="/createquote"
            element={<ProtectedRoute element={CreateQuote} />}
          />

          <Route path="/redirect" element={<RedirectPortal />}>
            <Route index element={<RedirectExisting />} />
            <Route path="ordersuccess" element={<OrderSuccess />} />
            <Route path="payment" element={<Payment />} />
            <Route path="track" element={<Track />} />
            <Route path="404" element={<NotFound />} />
          </Route>
          <Route
            path="/createstaff"
            element={<ProtectedRoute element={CreateStaffPage} />}
          />
          <Route
            path="/partnerregistration"
            element={<ProtectedRoute element={PartnerRegistration} />}
          />
          <Route
            path="/newpartnerregistration"
            element={<ProtectedRoute element={RegistrationFlow} />}
          />
          <Route
            path="/corporateregistration"
            element={<ProtectedRoute element={CorporateRegistration} />}
          />
          <Route
            path="/corporateregistration/business"
            element={<ProtectedRoute element={RegisterBusiness} />}
          />
          <Route
            path="/customerregistration"
            element={<ProtectedRoute element={CustomerRegistration} />}
          />
          <Route
            path="/create-group"
            element={<ProtectedRoute element={CreateGroup} />}
          />
          <Route
            path="/createorder"
            element={<ProtectedRoute element={OrderRouting} />}
          />
          <Route
            path="/neworder"
            element={<ProtectedRoute element={TravelBookingPage} />}
          />
          <Route path="/collectdocs" element={<CollectDocs />} />
          <Route path="/collect-docs" element={<LoginPage1 />} />
          <Route
            path="/createolddeal"
            element={<ProtectedRoute element={CreateOldDeal} />}
          />

          {/* Re - kyc route */}
          {/* <Route
            path="/re-kyc/:id"
            element={<ProtectedRoute element={ReKYCPage} />}
          /> */}

          {/* generic order creation */}
          <Route
            path="/generic-order-creation"
            element={<ProtectedRoute element={CreateGenericOrderPage} />}
          />

          {/* DELETE LATER */}

          <Route path="/lv-dashboard" element={<Home />} />

          {/* <Route path="/generate-quotation" element={<GenerateQuotation />} /> */}

          {/* 404 Not Found */}
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Suspense>
  );
};
export default ProjectRoutes;

const OrderRouting = () => {
  if (checkLevel(LEVEL_2)) {
    return <CreateOrderL2 />;
  }
  return <CreateOrder />;
};
